"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.Progress = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var createTheme_1 = require("../../styles/theme/createTheme");
function Progress(props) {
    var style = props.style, type = props.type, rest = __rest(props, ["style", "type"]);
    var _a = styles_1.useStyles(exports.createStyles, props), classes = _a.classes, css = _a.css;
    return react_1.default.createElement("progress", __assign({ className: css(classes.progress, style) }, rest));
}
exports.Progress = Progress;
Progress.defaultProps = {
    type: 'primary',
    max: 100,
};
exports.createStyles = function (theme, _a) {
    var type = _a.type;
    return ({
        progress: {
            appearance: 'none',
            border: 'none',
            height: 4,
            width: '100%',
            '&::-webkit-progress-bar': {
                backgroundColor: theme.pallete.gray.c90,
                borderRadius: 4,
            },
            '&::-webkit-progress-value': {
                backgroundColor: createTheme_1.getTextColor(theme, type),
                borderRadius: 4,
                transition: 'all .3s',
            },
            '&::-moz-progress-bar': {
                backgroundColor: createTheme_1.getTextColor(theme, type),
                borderRadius: 4,
                transition: 'all .3s',
            },
        },
    });
};
//# sourceMappingURL=Progress.js.map